var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('p'),_c('h5',[_vm._v(_vm._s(_vm.$t('objects.details.change-protocol')))]),_c('p')]),_vm._v(" "),_c('div',[(_vm.rmsobjectid)?_c('rms-objects-history-grid',{attrs:{"rmsobjectid":_vm.rmsobjectid}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }